import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIsStorageWritable } from '@features/storages'

import { allStoragesFilteredByTypesAndSearchSelector, allStoragesSelector } from '../selectors'
import { StorageType } from '../types'
import { createOptionsFromStorageList, getAllStorageTypes } from '../utils'

export function useAllStorages() {
  return useSelector(allStoragesSelector)
}

export function useAllStoragesFilteredByTypesAndSearch() {
  return useSelector(allStoragesFilteredByTypesAndSearchSelector)
}

export function useExistingStorageTypes(): StorageType[] {
  const storages = useAllStorages()
  return useMemo(
    () =>
      getAllStorageTypes().filter(storageType =>
        storages.some(storage => storage?.storageType?.includes(storageType))
      ),
    [storages]
  )
}

export const useOptionsForWritableStorages = () => {
  const allStorages = useSelector(allStoragesSelector)
  const isStorageWritable = useIsStorageWritable()

  return useMemo(() => {
    const writableStorages = allStorages.filter(isStorageWritable)
    return createOptionsFromStorageList(writableStorages)
  }, [allStorages])
}

export const useOptionsForAllStorages = () => {
  const allStorages = useSelector(allStoragesSelector)

  return useMemo(() => {
    return createOptionsFromStorageList(allStorages)
  }, [allStorages])
}
